
import { memo } from "react";
import { SetData } from "../types";
import { SeriesConfigSection } from "./personal-plan/sections/SeriesConfigSection";
import { RestTimesSection } from "./personal-plan/sections/RestTimesSection";
import { OptimizedIndividualSetEditingSection } from "./personal-plan/sections/OptimizedIndividualSetEditingSection";

interface PersonalPlanSelectorProps {
  exerciseId: string;
  sets: number;
  setRestTime: number;
  exerciseRestTime: number;
  setData: SetData[];
  reps: number;
  weight: number;
  onSetsChange: (value: string) => void;
  onSetRestTimeChange: (value: string) => void;
  onExerciseRestTimeChange: (value: string) => void;
  onSetDataChange: (setIndex: number, field: 'reps' | 'weight', value: string) => void;
}

export const PersonalPlanSelector = memo(function PersonalPlanSelector({
  exerciseId,
  sets,
  setRestTime,
  exerciseRestTime,
  setData,
  reps,
  weight,
  onSetsChange,
  onSetRestTimeChange,
  onExerciseRestTimeChange,
  onSetDataChange
}: PersonalPlanSelectorProps) {
  console.log(`🎯 PersonalPlanSelector render [${exerciseId}]:`, {
    sets,
    exerciseRestTime,
    setRestTime
  });

  return (
    <div className="space-y-4">
      <SeriesConfigSection
        exerciseId={exerciseId}
        sets={sets}
        onSetsChange={onSetsChange}
      />

      <OptimizedIndividualSetEditingSection
        exerciseId={exerciseId}
        sets={sets}
        setData={setData}
        reps={reps}
        weight={weight}
        onSetDataChange={onSetDataChange}
      />

      <RestTimesSection
        exerciseId={exerciseId}
        sets={sets}
        setRestTime={setRestTime}
        exerciseRestTime={exerciseRestTime}
        onSetRestTimeChange={onSetRestTimeChange}
        onExerciseRestTimeChange={onExerciseRestTimeChange}
      />
    </div>
  );
});
